import { render, staticRenderFns } from "./LessonTemplatePage.vue?vue&type=template&id=84c8fb34&scoped=true&"
import script from "./LessonTemplatePage.vue?vue&type=script&lang=js&"
export * from "./LessonTemplatePage.vue?vue&type=script&lang=js&"
import style0 from "./LessonTemplatePage.vue?vue&type=style&index=0&id=84c8fb34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c8fb34",
  null
  
)

export default component.exports